import axios from 'axios'
import {relaycfmPostRelayChannel, relaycfmPostRelayLecture} from './relayConfirm'
import config from '../config'

export function relayInit() {
    return {
        type: 'RELAY_INIT',
    }
}

export function relayShareInit (payload) {
    return {
        type: 'UPDATE_SHARE_DATA',
        payload,
    }
}

export function relaySetSort(sort) {
    return {
        type: 'RELAY_SET_SORT',
        payload: sort,
    }
}

export function relaySetLectureKeyword(payload) {
    return {
        type: 'RELAY_SET_LECTURE_KEYWORD',
        payload,
    }
}

export function relaySetLectureCheck(boolean) {
    return {
        type: 'RELAY_SET_LECTURE_CHECK',
        payload: boolean,
    }
}

export function relaySetCurrentLecture(lecture) {
    return {
        type: 'RELAY_SET_CURRENT_LECTURE',
        payload: lecture,
    }
}

export function relaySetLectureCheckRes(res) {
    return {
        type: 'RELAY_SET_LECTURE_CHECK_RES',
        payload: res,
    }
}

export function relayPostLectureCheck(id) {
    return dispatch => {
        dispatch(relaySetLectureCheck(true))
        return axios.post(`/api/relay/lecture/${id}/check`)
            .then(res => {
                dispatch(relaySetLectureCheck(false))
                dispatch(relaySetLectureCheckRes(res.data))
                if (res.data.code === 0 || res.data.code === -1) {
                    window.location = `/lecture/relay_confirm_new?id=${id}&type=lecture`
                }
            })
    }
}

export function newRelayPostLectureCheck(id) {
    return dispatch => {
        dispatch(relaySetLectureCheck(true))
        return axios.post(`/api/relay/lecture/${id}/check?is_from_marcket=1`)
            .then(res => {
                dispatch(relaySetLectureCheck(false))
                dispatch(relaySetLectureCheckRes(res.data))
                if (res.data.code === 0 || res.data.code === -1) {
                    dispatch(relaycfmPostRelayLecture(id, 'from_market'))
                    // window.location = `/lecture/relay_confirm_new?id=${id}&type=lecture`
                }
            })
    }
}

export function relaySetLectureListInit() {
    return {
        type: 'RELAY_SET_LECTURE_LIST_INIT',
    }
}

export function relaySetLectureList(list) {
    return {
        type: 'RELAY_SET_LECTURE_LIST',
        payload: list,
    }
}

export function relaySetLectureHasMore(boolean) {
    return {
        type: 'RELAY_SET_LECTURE_HAS_MORE',
        payload: boolean,
    }
}

export function relaySetLectureIsAsking(boolean) {
    return {
        type: 'RELAY_SET_LECTURE_IS_ASKING',
        payload: boolean,
    }
}

export function relaySetLectureOffset(offset) {
    return {
        type: 'RELAY_SET_LECTURE_OFFSET',
        payload: offset,
    }
}

export function relayFetchLectureList(opts = {}) {
    return (dispatch, getState) => {
        const relayState = getState().relay
        const offset = opts.offset || relayState.lectureOffset
        const order = opts.order || relayState.relaySort
        const keyword = opts.keyword == null ? relayState.lectureKeyword : opts.keyword
        dispatch(relaySetLectureIsAsking(true))
        axios.get(`/api/relay/lecture/list?offset=${offset}&order_by=${order}&keyword=${keyword}`)
            .then(res => {
                dispatch(relaySetLectureList([...(relayState.lectureList || []), ...res.data.data.lectures]))
                dispatch(relaySetLectureOffset(res.data.data.next_offset))
                dispatch(relaySetLectureHasMore(res.data.data.has_more))
                dispatch(relaySetLectureIsAsking(false))
            })
    }
}

// channel

export function relaySetChannelKeyword(payload) {
    return {
        type: 'RELAY_SET_CHANNEL_KEYWORD',
        payload,
    }
}

export function relaySetChannelList(list) {
    return {
        type: 'RELAY_SET_CHANNEL_LIST',
        payload: list,
    }
}

export function relaySetCurrentChannel(channel) {
    return {
        type: 'RELAY_SET_CURRENT_CHANNEL',
        payload: channel,
    }
}

export function relaySetChannelCheck(boolean) {
    return {
        type: 'RELAY_SET_CHANNEL_CHECK',
        payload: boolean,
    }
}

export function relaySetChannelCheckRes(res) {
    return {
        type: 'RELAY_SET_CHANNEL_CHECK_RES',
        payload: res,
    }
}

export function relayPostChannelCheck(id) {
    return dispatch => {
        dispatch(relaySetChannelCheck(true))
        return axios.post(`/api/relay/channel/${id}/check`)
            .then(res => {
                dispatch(relaySetChannelCheck(false))
                dispatch(relaySetChannelCheckRes(res.data))
                if (res.data.code === 0 || res.data.code === -1) {
                    window.location = `/lecture/relay_confirm_new?id=${id}&type=channel`
                }
            })
    }
}

export function newRelayPostChannelCheck(id) {
    return dispatch => {
        dispatch(relaySetChannelCheck(true))
        return axios.post(`/api/relay/channel/${id}/check?is_from_marcket=1`)
            .then(res => {
                dispatch(relaySetChannelCheck(false))
                dispatch(relaySetChannelCheckRes(res.data))
                if (res.data.code === 0 || res.data.code === -1) {
                    dispatch(relaycfmPostRelayChannel(id, 'from_marcket'))
                    // window.location = `/lecture/relay_confirm_new?id=${id}&type=channel`
                }
            })
    }
}

export function relaySetChannelOffset(offset) {
    return {
        type: 'RELAY_SET_CHANNEL_OFFSET',
        payload: offset,
    }
}

export function relaySetChannelHasMore(boolean) {
    return {
        type: 'RELAY_SET_CHANNEL_HAS_MORE',
        payload: boolean,
    }
}

export function relaySetChannelIsAsking(boolean) {
    return {
        type: 'RELAY_SET_CHANNEL_IS_ASKING',
        payload: boolean,
    }
}

export function relaySetShareInfo(data) {
    return {
        type: 'UPDATE_SHARE_DATA',
        payload: data,
    }
}

export function relayFetchChannelList(opts = {}) {
    return (dispatch, getState) => {
        const relayState = getState().relay
        const offset = opts.offset || relayState.channelOffset
        const keyword = opts.keyword || relayState.channelKeyword
        dispatch(relaySetChannelIsAsking(true))
        axios.get(`/api/relay/channel/list?offset=${offset}&keyword=${keyword}`)
            .then(res => {
                dispatch(relaySetChannelList([ ...(relayState.channelList || []), ...res.data.data.records ]))
                dispatch(relaySetChannelOffset(res.data.data.next_offset))
                dispatch(relaySetChannelHasMore(res.data.data.has_more))
                dispatch(relaySetChannelIsAsking(false))
            })
    }
}






// WEBPACK FOOTER //
// ./src/actions/relays.js